(function() {
  let scheduled = false;

  function luminance(color) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    return match ? 0.299 * Number(match[1]) + 0.587 * Number(match[2]) + 0.114 * Number(match[3]) : null;
  }

  function isTransparent(color) {
    return color === 'rgba(0, 0, 0, 0)' || color === 'transparent';
  }

  function updateHeaderColor() {
    scheduled = false;
    // Reacquire the Header after Theme Editor section rendering.
    const header = document.querySelector('.section-header .header');
    if (!header) return;
    const rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
    const x = window.innerWidth / 2;
    const y = Math.max(0, Math.min(window.innerHeight - 1, rect.top + rect.height / 2));
    const el = document.elementsFromPoint(x, y).find(node => !node.closest('.section-header'));
    if (!el) return;

    // Background media uses the Section's existing text-color direction,
    // not the solid fallback color behind its image/video. No pixel sampling.
    const visual = el.closest('.hero-banner, .section-full-width-banner__container.media-position--background');
    if (visual) {
      const coversPoint = Array.from(visual.querySelectorAll('.hero__media, .section-full-width-banner__media')).some(media => {
        const box = media.getBoundingClientRect();
        return box.left <= x && box.right > x && box.top <= y && box.bottom > y &&
          window.getComputedStyle(media).visibility !== 'hidden';
      });
      const content = visual.matches('.hero-banner') ? visual : visual.querySelector('.section-full-width-banner__content');
      if (coversPoint && content) {
        const foreground = luminance(window.getComputedStyle(content).color);
        if (foreground !== null) {
          header.classList.toggle('header--dark-text', foreground <= 128);
          return;
        }
      }
    }

    let target = el;
    let bg = 'rgba(0, 0, 0, 0)';
    while (target && target !== document.body) {
      bg = window.getComputedStyle(target).backgroundColor;
      if (bg && !isTransparent(bg)) break;
      target = target.parentElement;
    }
    if (isTransparent(bg)) bg = window.getComputedStyle(document.body).backgroundColor;
    if (isTransparent(bg)) bg = window.getComputedStyle(document.documentElement).backgroundColor;
    const background = isTransparent(bg) ? null : luminance(bg);
    header.classList.toggle('header--dark-text', background !== null && background > 128);
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateHeaderColor);
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);
  document.addEventListener('load', event => {
    if (event.target.matches && event.target.matches('img, video, iframe')) scheduleUpdate();
  }, true);
  document.addEventListener('loadeddata', scheduleUpdate, true);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => {
    document.addEventListener(event, scheduleUpdate);
  });
  scheduleUpdate();
})();
